import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";
import { formataData } from "../../../helpers/mesesHelper";
import Badge from "../../../components/Common/Badge";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import { handleChange } from "../../../helpers/handleFormChanges";
import CommonSelect from "../../../components/forms/CommonSelect";
import useTipos from "../../../hooks/common/useTipos";

function CertificadoVencerDataTable({
  certificados,
  togNovoContatoCertificadoModal,
  filtroHook,
}) {
  const { filtroValues, setFiltroValues } = filtroHook;
  const tiposPlanos = useTipos("tipos_planos");
  const tiposRegimes = useTipos("tipos_regimes");

  const colunas = React.useMemo(
    () => [
      {
        Header: "Razão social",
        accessor: "razao_social",
      },
      {
        Header: "CNPJ",
        accessor: (row) => {
          return Format.formatCNPJCPF(row.cnpj);
        },
        disableSortBy: true,
      },
      {
        Header: "Vencimento",
        accessor: (row) => {
          return row.vencimento === "None" ? "-" : formataData(row.vencimento);
        },
        disableSortBy: true,
      },
      {
        Header: "Regime",
        accessor: (row) => {
          return row.regime === 0
            ? "Sem regime"
            : (tiposRegimes &&
                tiposRegimes.find((regime) => parseInt(regime.chave) === parseInt(row.regime))
                  ?.valor) ||
                "Sem regime";
        },
        disableSortBy: true,
      },
      {
        Header: "Plano",
        accessor: (row) => {
          return row.plano === 0
            ? "Sem plano"
            : (tiposPlanos &&
                tiposPlanos.find((plano) => parseInt(plano.chave) === parseInt(row.plano))
                  ?.valor) ||
                "Sem plano";
        },
        disableSortBy: true,
      },
      {
        Header: "Status",
        accessor: (row) => {
          let status = [];

          switch (row.status) {
            case "prestes a vencer":
              status.push(
                <div>
                  <Badge color="warning">Prestes a vencer</Badge>
                </div>
              );
              break;

            case "vencido":
              status.push(
                <div>
                  <Badge color="danger">Vencido</Badge>
                </div>
              );
              break;

            case "valido":
              status.push(
                <div>
                  <Badge color="success">Válido</Badge>
                </div>
              );
              break;

            default:
              break;
          }

          return (
            <div>
              <div className="mb-2" role="group">
                {status}
              </div>
            </div>
          );
        },
        disableSortBy: true,
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <CommonDropdown>
              <DropdownButton
                key={`tog-modal-${row.original.uid}`}
                onClick={() => {
                  togNovoContatoCertificadoModal(row.original.uid);
                }}
                color="primary"
                icon="mdi mdi-eye"
              >
                Contato
              </DropdownButton>
            </CommonDropdown>
          );
        },
      },
    ],
    [togNovoContatoCertificadoModal, tiposPlanos, tiposRegimes]
  );

  return (
    <>
      <div className="row">
        <div className="col-md-3 mb-3">
          <CommonInputDate
            label="Período inicial"
            id="inicio"
            value={filtroValues.inicio}
            onChange={(e) => handleChange(e, filtroValues, setFiltroValues)}
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonInputDate
            label="Período final"
            id="fim"
            value={filtroValues.fim}
            onChange={(e) => handleChange(e, filtroValues, setFiltroValues)}
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonSelect
            label="Status"
            id="status"
            value={filtroValues.status}
            onChange={(e) => handleChange(e, filtroValues, setFiltroValues)}
            data={[
              {
                text: "Todos",
                id: "todos",
              },
              {
                text: "Prestes a vencer",
                id: "prestes a vencer",
              },
              {
                text: "Vencido",
                id: "vencido",
              },
              {
                text: "Válido",
                id: "valido",
              },
            ]}
            placeholder="Selecione"
          />
        </div>
      </div>
      <CommonDataTable colunas={colunas} linhas={certificados} botoes={<></>} />
    </>
  );
}

CertificadoVencerDataTable.propTypes = {
  certificados: PropTypes.array.isRequired,
  togNovoContatoCertificadoModal: PropTypes.func.isRequired,
  filtroHook: PropTypes.object.isRequired,
  row: PropTypes.object,
};

export default CertificadoVencerDataTable;
